import React, { useState } from "react";
import StatusBar from "../StatusBar/StatusBar";
import "./TheGramStoriesApp.css";
import "../MessageApp/Messages.css";
import GramStoriesPost from "./GramStoriesPost";
import Messages from "../MessageApp/Messages";
import { Chat_content } from "../MessageApp/MessagesInterfaces";
import { GramStoriesPostProps } from "./TheGramStoriesAppInterfaces";
import GramLogo from "./MMC_Phone App_TheGram.svg";
import GramHomeButton from "./MMC_Phone App_TheGram_Home.svg";
import GramDmButton from "./MMC_Phone App_TheGram_DM.svg";

interface TheGramStoriesAppProps {
  content: GramStoriesPostProps[];
  messages?: Chat_content[];
  notifications: number;
  handleStateChange?: (chat: Chat_content) => void;
  onReturnHome?: () => void;
}

const TheGramStoriesApp: React.FC<TheGramStoriesAppProps> = ({
  content,
  messages,
  notifications,
  handleStateChange,
  onReturnHome,
}) => {
  const [showMessages, setShowMessages] = useState(false);
  const [currentPostIndex, setCurrentPostIndex] = useState(0);

  const handleMessageClick = () => {
    setShowMessages(true);
  };

  const handleHomeClick = () => {
    setShowMessages(false);
  };

  const handlePostClick = () => {
    // Keep the center click functionality to go forward
    handleNextPost();
  };

  const handleNextPost = () => {
    if (currentPostIndex < content.length - 1) {
      // Move to next post
      setCurrentPostIndex(currentPostIndex + 1);
    } else {
      // Last post - return to home
      if (onReturnHome) {
        onReturnHome();
      }
    }
  };

  const handlePreviousPost = () => {
    if (currentPostIndex > 0) {
      setCurrentPostIndex(currentPostIndex - 1);
    }
  };

  return (
    <>
      {!showMessages ? (
        <div className={`thegramstories-app`}>
          <div className="thegramstories-app-status-bar">
            <StatusBar />
          </div>

          <div className="gramstories-posts-list" onClick={handlePostClick}>
            {content.length > 0 && (
              <GramStoriesPost post={content[currentPostIndex]} />
            )}

            {/* Left Arrow Button (Previous) */}
            {currentPostIndex > 0 && (
              <button
                className="gramstories-nav-arrow gramstories-nav-arrow-left"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePreviousPost();
                }}
                aria-label="Previous story"
              >
                <span className="gramstories-arrow-icon">‹</span>
              </button>
            )}

            {/* Right Arrow Button (Next) */}
            <button
              className="gramstories-nav-arrow gramstories-nav-arrow-right"
              onClick={(e) => {
                e.stopPropagation();
                handleNextPost();
              }}
              aria-label="Next story"
            >
              <span className="gramstories-arrow-icon">›</span>
            </button>
          </div>
        </div>
      ) : (
        messages && (
          <div style={{ background: "lightgrey", height: "100%" }}>
            <Messages
              influencerMessageContent={messages}
              theGram={true}
              handleStateChange={handleStateChange}
              handleHomeClick={() => setShowMessages(false)}
            />
          </div>
        )
      )}
    </>
  );
};

export default TheGramStoriesApp;
